let url = "https://www.facebook.com/AuraSkinPremium"

  function handleSocialShare(platform) {
        const url = encodeURIComponent(this.articleUrl);
        const title = encodeURIComponent(this.articleTitle);
        const excerpt = encodeURIComponent(this.articleExcerpt);

        let shareUrl = '';

        switch (platform) {
          case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            break;
          case 'twitter':
            shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
            break;
          case 'linkedin':
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
            break;
          case 'pinterest':
            shareUrl = `https://pinterest.com/pin/create/button/?url=${url}&description=${title}`;
            break;
          case 'email':
            shareUrl = `mailto:?subject=${title}&body=Check out this article: ${url}`;
            break;
          case 'copy':
            this.copyToClipboard();
            return;
        }

        if (shareUrl) {
          console.log('shareUrl', shareUrl);
          window.open(shareUrl, '_blank', 'width=600,height=400');
        }
      }

export const socialLinks = {
  // facebookold: "https://www.facebook.com/share/16uSZZEHr8/",
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  instagram: "https://www.instagram.com/auraskinpremium",
  whatsapp: "https://wa.me/923117266767", // WhatsApp API link
  tiktok: "https://www.tiktok.com/@auraskinpremium",
};
